<div
  class="request-information-container"
  *ngIf="selectedCategory"
>


  <div class="request-description-section">
    <h2>{{ 'request_v2.create-request-dialog.request-information.describe-situation' | translate }}</h2>
    <p class="helper-text">
      {{ 'request_v2.create-request-dialog.request-information.describe-helper' | translate }}
    </p>

    <app-form-textarea
      [(ngModel)]="requestDescription"
      (change)="onDescriptionChange($event)"
      [placeholder]="'request_v2.create-request-dialog.request-information.describe-placeholder' | translate"
      [rows]="6"
      [wordLimit]="maxWordCount"
      [validation]="true"
      [disableMessages]="false"
    ></app-form-textarea>
  </div>


  <div class="file-attachment-section">
    <h2>{{ 'request_v2.create-request-dialog.request-information.share-files' | translate }}</h2>
    <p class="helper-text">
      {{ 'request_v2.create-request-dialog.request-information.share-helper' | translate }}
    </p>
    <app-file-attachment
      [maxFiles]="maxFiles"
      [maxFileSizeMB]="maxFileSizeMB"
      [acceptedFileTypes]="acceptedFileTypes"
      [initialFiles]="initialFiles"
      [hasError]="exceedsFileSizeLimit"
      (filesChanged)="onAttachedFilesChanged($event)"
    >
    </app-file-attachment>
  </div>

  <div class="request-links-section">
    <app-create-request-links
      [links]="requestLinks"
      (linksChanged)="onRequestLinksChanged($event)"
    ></app-create-request-links>
  </div>

</div>
